import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import schema from './schema';
import View from './View';
import BlockImageInput from '../../helpers/BlockImageInput/BlockImageInput';

const DISH_FIELDS = new Set(['dish1_image', 'dish2_image', 'dish3_image']);

const Edit = (props: any) => {
  const {
    onChangeBlock,
    data,
    block,
    selected,
    navRoot,
    contentType,
    blocksErrors,
  } = props;
  const blockSchema = schema(props);

  const imageSlot = ({ fieldId, value, element }: any) => {
    if (!DISH_FIELDS.has(fieldId)) return undefined;
    return (
      <BlockImageInput
        id={fieldId}
        block={block}
        value={value}
        imageSize="large"
        onChange={(next) => onChangeBlock(block, { ...data, [fieldId]: next })}
      >
        {element}
      </BlockImageInput>
    );
  };

  return (
    <>
      <View data={data} isEditMode imageSlot={imageSlot} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={blockSchema}
          title={blockSchema.title}
          onChangeField={(id: string, value: any) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
          navRoot={navRoot}
          contentType={contentType}
          errors={blocksErrors}
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
